import React, { useState } from 'react';
import axios from 'axios';
import './Support.css';

const Support = () => {
  const [status, setStatus] = useState('idle'); // idle, sending, success, error
  const [errorMessage, setErrorMessage] = useState('');
  return (
    <div className="support-container">
      <h1>Support Ciné Séries App</h1>
      
      <section className="support-section">
        <h2>Aide et assistance</h2>
        <p>
          Bienvenue sur la page de support de Ciné Séries App. Si vous rencontrez des problèmes avec l'application ou avez des questions, nous sommes là pour vous aider.
        </p>
      </section>

      <section className="support-section">
        <h2>FAQ</h2>
        <div className="faq-item">
          <h3>Comment noter un film ?</h3>
          <p>
            Pour noter un film, recherchez-le dans l'application, ouvrez sa page et utilisez le système de notation sur 5 étoiles. Vous pouvez également ajouter un commentaire pour partager votre avis.
          </p>
        </div>
        
        <div className="faq-item">
          <h3>Comment gérer ma liste de films à voir ?</h3>
          <p>
            Vous pouvez ajouter des films à votre liste en cliquant sur l'icône "+" sur la page d'un film. Retrouvez votre liste dans la section "Ma Liste" de l'application.
          </p>
        </div>
        
        <div className="faq-item">
          <h3>Comment suivre d'autres utilisateurs ?</h3>
          <p>
            Visitez le profil d'un utilisateur et cliquez sur le bouton "Suivre". Vous verrez ensuite leurs activités dans votre fil d'actualité.
          </p>
        </div>

        <div className="faq-item">
          <h3>Comment avoir des recommendations personnalisées ?</h3>
          <p>
            Une fois que vous avez noté plusieurs films, visitez la section "Mes Recommendations" (en haut de la section Ma Liste) pour obtenir des suggestions personnalisées basées sur vos goûts.
          </p>
        </div>

      </section>

      <section className="support-section">
        <h2>Nous contacter</h2>
        <p>
          En cas de problème technique, de question ou de suggestion, n'hésitez pas à nous contacter en remplissant le formulaire ci-dessous.
          Nous vous répondrons dans les plus brefs délais pour vous aider.
        </p>
        <form 
          className="contact-form"
          onSubmit={async (e) => {
            e.preventDefault();
            setStatus('sending');
            setErrorMessage('');
            
            const formData = new FormData(e.target);
            const data = {
              email: formData.get('email'),
              subject: formData.get('subject'),
              message: formData.get('message')
            };

            try {
              await axios.post('/api/send-support-email', data);
              setStatus('success');
              e.target.reset();
              setTimeout(() => setStatus('idle'), 3000);
            } catch (error) {
              setStatus('error');
              setErrorMessage(error.response?.data?.detail || 'Une erreur est survenue lors de l\'envoi');
            }
          }}
        >
          <div className="form-group">
            <label htmlFor="email">Votre email :</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              required 
              placeholder="votre@email.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Sujet :</label>
            <input 
              type="text" 
              id="subject" 
              name="subject" 
              required 
              placeholder="Ex: Demande de fonctionnalité, Problème technique..."
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="message">Message :</label>
            <textarea 
              id="message" 
              name="message" 
              required 
              rows="5"
              placeholder="Décrivez votre problème ou votre question..."
            ></textarea>
          </div>
          
          <button 
            type="submit" 
            className={`submit-button ${status === 'sending' ? 'sending' : ''}`}
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Envoi en cours...' : 'Envoyer le message'}
          </button>

          {status === 'success' && (
            <div className="success-message">
              Message envoyé avec succès ! 
              Nous reviendrons vers vous au plus vite.
            </div>
          )}

          {status === 'error' && (
            <div className="error-message">
              {errorMessage}
            </div>
          )}
        </form>
      </section>

      <section className="support-section">
        <h2>Confidentialité et conditions d'utilisation</h2>
        <p>
          FilmsRanker respecte votre vie privée et protège vos données personnelles. Pour en savoir plus, consultez notre :
        </p>
        <ul>
          <li><a href="/privacy">Politique de confidentialité</a></li>
          <li><a href="/terms">Conditions d'utilisation</a></li>
        </ul>
      </section>

      <div className="footer-links">
        <a href="/privacy">Politique de confidentialité</a>
        <a href="/terms">Conditions d'utilisation</a>
      </div>
    </div>
  );
};

export default Support;
